"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var WaitingDialog_1 = require("./WaitingDialog");
var PublishingWaitingDialog = /** @class */ (function (_super) {
    __extends(PublishingWaitingDialog, _super);
    function PublishingWaitingDialog(props) {
        var _this = _super.call(this, props) || this;
        // TODO this may not get called, because we reload the page to finish.
        // We may need to extract the openDurationMs calculation and use window.onbeforeunload instead.
        _this.wrappedOnCloseRequest = function (openDurationMs) {
            _this.props.JumpstartTelemetry.PublishingWaiting.Close(openDurationMs);
            _this.props.onCloseRequest();
        };
        return _this;
    }
    PublishingWaitingDialog.prototype.componentDidMount = function () {
        this.props.JumpstartTelemetry.PublishingWaiting.Open();
    };
    PublishingWaitingDialog.prototype.render = function () {
        var dialogProps = {
            title: Localize_1.Messages.CreatingWorkbookDialogTitle(),
            showFooterButton: false,
            onCloseRequest: this.wrappedOnCloseRequest,
            testId: 'PublishingWaitingDialog',
        };
        return React.createElement(WaitingDialog_1.WaitingDialog, __assign({}, dialogProps));
    };
    return PublishingWaitingDialog;
}(React.Component));
exports.PublishingWaitingDialog = PublishingWaitingDialog;
//# sourceMappingURL=PublishingWaitingDialog.js.map